import React from "react";
import { CheckIcon } from "../icons";
import { STEPS } from "./leagueWizardConfig";

// Create League stepper — ONE treatment for mobile and desktop (the desktop
// style), because the old mobile variant's connector lines didn't meet the
// circles.
//
// How the lines connect cleanly at every width: each step is an equal-width
// column, and the connector is two half-width rules pinned at `top-[17px]` —
// the vertical centre of the 34px circle — so they always meet the circle's
// middle instead of being nudged into place with a margin. The circles sit above
// them (z-10, solid background), so the rule disappears behind each circle.
//
// Every circle is a button: the user can jump to any step. Jumping backwards is
// always allowed; jumping forwards is validated by the caller so required
// fields can't be skipped.
const WizardStepper = ({ step, onSelect, maxReachable = STEPS.length }) => (
  <nav aria-label="Progress" className="mt-5 mb-3">
    <ol className="flex items-start max-w-md mx-auto">
      {STEPS.map((s, i) => {
        const isDone = step > s.n;
        const isActive = step === s.n;
        const reachable = s.n <= maxReachable;
        return (
          <li key={s.n} className="relative flex-1 flex flex-col items-center">
            {i > 0 && (
              <span
                aria-hidden="true"
                className={`absolute top-[17px] left-0 w-1/2 h-px ${
                  step >= s.n ? "bg-[#22A36B]" : "bg-[#E5E7EB]"
                }`}
              />
            )}
            {i < STEPS.length - 1 && (
              <span
                aria-hidden="true"
                className={`absolute top-[17px] right-0 w-1/2 h-px ${
                  step > s.n ? "bg-[#22A36B]" : "bg-[#E5E7EB]"
                }`}
              />
            )}

            <button
              type="button"
              onClick={() => reachable && onSelect?.(s.n)}
              disabled={!reachable}
              aria-current={isActive ? "step" : undefined}
              aria-label={`Step ${s.n}: ${s.label}`}
              className={`group relative z-10 flex flex-col items-center ${
                reachable ? "cursor-pointer" : "cursor-default"
              }`}
            >
              <span
                className={`w-[34px] h-[34px] rounded-full flex items-center justify-center text-sm font-semibold border transition-all ${
                  isDone
                    ? "bg-white border-[#22A36B] text-[#22A36B]"
                    : isActive
                    ? "bg-[#22A36B] border-[#22A36B] text-white"
                    : "bg-white border-[#D1D5DB] text-[#9CA3AF]"
                } ${reachable ? "md:group-hover:-translate-y-0.5 md:group-hover:shadow-sm" : ""}`}
              >
                {isDone ? <CheckIcon className="w-4 h-4" stroke="#22A36B" /> : s.n}
              </span>
              <span
                className={`mt-1.5 text-xs whitespace-nowrap transition-colors ${
                  isActive
                    ? "text-[#22A36B] font-semibold"
                    : isDone
                    ? "text-[#0F172A]"
                    : "text-tertiary"
                } ${reachable ? "md:group-hover:text-[#0F172A]" : ""}`}
              >
                {s.label}
              </span>
            </button>
          </li>
        );
      })}
    </ol>
  </nav>
);

export default WizardStepper;
